export default __webpack_public_path__ + "static/media/title_reservation.3fe4dd2d.jpg";